(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uhs-contact-case-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('uhs-contact-case-form')) {
    customElements.define(
      'uhs-contact-case-form',
      class UhsContactCaseForm extends HTMLElement {
        connectedCallback() {
          this.panels = {
            picker: this.querySelector('[data-contact-panel="picker"]'),
            forms: this.querySelector('[data-contact-panel="forms"]'),
            service: this.querySelector('[data-contact-panel="service"]'),
            sales: this.querySelector('[data-contact-panel="sales"]'),
          };
          this.netsuiteFrame = this.querySelector('.uhs-contact__netsuite');

          this._onClick = (event) => {
            const choose = event.target.closest('[data-contact-choose]');
            if (choose) this.show(choose.dataset.contactChoose);
            else if (event.target.closest('[data-contact-back]')) this.show('picker');
          };
          this.addEventListener('click', this._onClick);

          // The NetSuite form posts its own height so the iframe can fit it without an
          // inner scrollbar. Same origin check and sanity bounds as the live theme.
          this._onMessage = (event) => {
            if (!this.netsuiteFrame || event.origin !== this.dataset.netsuiteOrigin) return;
            const height = event.data && event.data.uhsFormHeight;
            if (!height || height < 300 || height > 3000) return;
            this.netsuiteFrame.style.height = `${height}px`;
          };
          window.addEventListener('message', this._onMessage);
        }

        disconnectedCallback() {
          this.removeEventListener('click', this._onClick);
          window.removeEventListener('message', this._onMessage);
        }

        show(view) {
          const isPicker = view === 'picker';
          this.dataset.view = view;
          this.panels.picker.hidden = !isPicker;
          this.panels.forms.hidden = isPicker;
          this.panels.service.hidden = view !== 'service';
          this.panels.sales.hidden = view !== 'sales';
          if (view === 'sales') this.loadFormsite();

          const focusTarget = isPicker
            ? this.querySelector(`[data-contact-choose="${this.lastChoice}"]`)
            : this.panels[view].querySelector('h2') || this.panels[view];
          if (!isPicker) this.lastChoice = view;
          if (focusTarget) {
            if (!focusTarget.matches('button')) focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus({ preventScroll: true });
          }
          // Bring the new view's top into sight when the swap left it above the viewport.
          if (this.getBoundingClientRect().top < 0) this.scrollIntoView({ block: 'start', behavior: 'smooth' });
        }

        // Formsite's embedManager.js inserts its iframe before #formAnchor<id> and resizes
        // it from postMessage, so it is only fetched once someone actually picks Sales.
        loadFormsite() {
          const key = this.dataset.formsiteKey;
          if (!key || this.formsiteRequested) return;
          this.formsiteRequested = true;
          const embed = () =>
            window.EmbedManager.embed({
              key,
              width: '100%',
              title: this.querySelector('[data-contact-choose="sales"]').textContent.trim(),
            });
          if (window.EmbedManager) return embed();
          const script = document.createElement('script');
          script.src = this.dataset.formsiteScript;
          script.async = true;
          script.onload = embed;
          document.head.appendChild(script);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uhs-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uhs-header')) {
  customElements.define(
    'uhs-header',
    class extends HTMLElement {
      connectedCallback() {
        if (this.classList.contains('uhs-header-wrapper--sticky')) {
          this._onScroll = () => {
            this.classList.toggle('uhs-header-wrapper--scrolled', window.scrollY > 4);
          };
          this._onScroll();
          window.addEventListener('scroll', this._onScroll, { passive: true });
        }

        this.initHeaderHeightVar();
        this.initMobileNav();
      }

      disconnectedCallback() {
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        if (this._headerResizeObserver) this._headerResizeObserver.disconnect();
      }

      // YMM finder bar (sections/uhs-ymm-finder.liquid) reads this to sit its sticky
      // offset directly under the header, whatever height the header wraps to.
      initHeaderHeightVar() {
        // Only meaningful while the header is actually pinned. A non-sticky header
        // must leave this unset so the YMM bar's `top: var(--uhs-header-h, 0px)`
        // falls back to 0 instead of pinning below a header that scrolled away.
        if (!this.classList.contains('uhs-header-wrapper--sticky')) return;
        const setVar = () => {
          document.documentElement.style.setProperty('--uhs-header-h', `${this.offsetHeight}px`);
        };
        setVar();
        if (window.ResizeObserver) {
          this._headerResizeObserver = new ResizeObserver(setVar);
          this._headerResizeObserver.observe(this);
        } else {
          window.addEventListener('resize', setVar);
        }
      }

      initMobileNav() {
        this.menuToggle = this.querySelector('.uhs-header__menu-toggle');
        // Drawer is a sibling in markup (see file-header comment), not a descendant.
        this.mobileNav = document.getElementById(`uhs-mobile-nav-${this.dataset.section}`);
        if (!this.menuToggle || !this.mobileNav) return;

        this.mnavBackBtn = this.mobileNav.querySelector('.uhs-mobile-nav__back');
        this.mnavCloseBtn = this.mobileNav.querySelector('.uhs-mobile-nav__close');
        this.mnavTopbar = this.mobileNav.querySelector('.uhs-mobile-nav__topbar');
        this.mnavStack = [];
        this.mnavCurrent = this.mobileNav.querySelector('.uhs-mobile-nav__level.is-active');

        this.menuToggle.addEventListener('click', () => this.openMobileNav());
        this.mobileNav.querySelectorAll('[data-mobile-nav-close]').forEach((el) => {
          el.addEventListener('click', () => this.closeMobileNav());
        });
        this.mobileNav.addEventListener('click', (event) => {
          const openBtn = event.target.closest('[data-open-level]');
          if (openBtn) {
            this.mnavGoToId(openBtn.dataset.openLevel, 'forward');
            return;
          }
          if (event.target.closest('[data-back]')) this.mnavGoBack();
        });
        this._onMnavKeyup = (event) => {
          if (event.key === 'Escape') this.closeMobileNav();
        };
      }

      openMobileNav() {
        this.mobileNav.hidden = false;
        requestAnimationFrame(() => this.mobileNav.classList.add('is-open'));
        this.menuToggle.setAttribute('aria-expanded', 'true');
        this.classList.add('uhs-header--menu-open');
        document.body.classList.add('overflow-hidden-mobile', 'uhs-mobile-nav-open');
        document.addEventListener('keyup', this._onMnavKeyup);
        if (typeof trapFocus === 'function') {
          trapFocus(this.mobileNav, this.menuToggle);
        }
      }

      closeMobileNav() {
        this.mobileNav.classList.remove('is-open');
        this.menuToggle.setAttribute('aria-expanded', 'false');
        this.classList.remove('uhs-header--menu-open');
        document.body.classList.remove('overflow-hidden-mobile', 'uhs-mobile-nav-open');
        document.removeEventListener('keyup', this._onMnavKeyup);
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.menuToggle);

        window.setTimeout(() => {
          if (this.mobileNav.classList.contains('is-open')) return;
          this.mobileNav.hidden = true;
          this.mnavReset();
        }, 250);
      }

      mnavReset() {
        this.mobileNav.querySelectorAll('.uhs-mobile-nav__level').forEach((level) => {
          level.classList.remove('is-active');
        });
        const root = this.mobileNav.querySelector('[data-level="root"]');
        root.classList.add('is-active');
        this.mnavCurrent = root;
        this.mnavStack = [];
        this.mnavUpdateTopbar();
      }

      // Root level gets only the Close button; drilled-in levels also show Back.
      mnavUpdateTopbar() {
        const isRoot = this.mnavCurrent.dataset.level === 'root';
        this.mnavBackBtn.hidden = isRoot;
        this.mnavTopbar.classList.toggle('has-back', !isRoot);
      }

      mnavGoToId(targetId, direction) {
        const target = this.mobileNav.querySelector('#' + CSS.escape(targetId));
        if (target) this.mnavShow(target, direction);
      }

      mnavGoBack() {
        const target = this.mnavStack.pop();
        if (target) this.mnavShow(target, 'backward');
      }

      mnavShow(target, direction) {
        if (!this.mnavCurrent || target === this.mnavCurrent) return;
        const leaving = this.mnavCurrent;

        if (direction === 'forward') this.mnavStack.push(leaving);
        leaving.classList.remove('is-active');
        target.classList.add('is-active');
        this.mnavCurrent = target;
        this.mnavUpdateTopbar();
        (this.mnavBackBtn.hidden ? this.mnavCloseBtn : this.mnavBackBtn).focus();
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uhs-mega-menu"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('uhs-mega-menu')) {
  customElements.define(
    'uhs-mega-menu',
    class extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(
          this.querySelectorAll('[data-menu-trigger]')
        );

        this.menus = Array.from(
          this.querySelectorAll('[data-menu]')
        );

        this.backdrop = this.querySelector(
          '[data-menu-backdrop]'
        );

        this.activeMenu = null;
        this.activeTrigger = null;
        this.activeView = null;

        this.handleClick =
          this.onClick.bind(this);

        this.handleKeydown =
          this.onKeydown.bind(this);

        this.handleResize =
          this.onResize.bind(this);

        this.addEventListener(
          'click',
          this.handleClick
        );

        document.addEventListener(
          'keydown',
          this.handleKeydown
        );

        window.addEventListener(
          'resize',
          this.handleResize
        );
      }

      disconnectedCallback() {
        this.removeEventListener(
          'click',
          this.handleClick
        );

        document.removeEventListener(
          'keydown',
          this.handleKeydown
        );

        window.removeEventListener(
          'resize',
          this.handleResize
        );
      }

      onClick(event) {
        const trigger = event.target.closest(
          '[data-menu-trigger]'
        );

        if (trigger && this.contains(trigger)) {
          event.preventDefault();

          this.toggleMenu(trigger);
          return;
        }

        const close = event.target.closest(
          '[data-close-menu]'
        );

        if (close && this.contains(close)) {
          event.preventDefault();

          this.closeMenu();
          return;
        }

        const back = event.target.closest(
          '[data-back-menu]'
        );

        if (back && this.contains(back)) {
          event.preventDefault();

          this.backToMain();
          return;
        }

        const submenuTrigger =
          event.target.closest(
            '[data-submenu-trigger]'
          );

        if (
          submenuTrigger &&
          this.contains(submenuTrigger)
        ) {
          event.preventDefault();

          this.openSubmenu(submenuTrigger);
          return;
        }

        if (
          this.backdrop &&
          event.target === this.backdrop
        ) {
          this.closeMenu();
        }
      }

      onKeydown(event) {
        if (
          event.key !== 'Escape' ||
          !this.activeMenu
        ) {
          return;
        }

        const views =
          this.activeMenu.querySelector(
            '[data-menu-views]'
          );

        if (
          views &&
          views.classList.contains('is-sub')
        ) {
          this.backToMain();
        } else {
          this.closeMenu();
        }
      }

      onResize() {
        if (
          this.activeMenu &&
          this.activeView
        ) {
          this.applyPanelHeightFor(
            this.activeView
          );
        }
      }

      toggleMenu(trigger) {
        const menuId =
          trigger.dataset.menuTrigger;

        const menu = this.querySelector(
          `[data-menu="${CSS.escape(menuId)}"]`
        );

        if (!menu) return;

        const isSameMenu =
          this.activeMenu === menu &&
          menu.classList.contains('is-open');

        if (isSameMenu) {
          this.closeMenu();
          return;
        }

        this.closeMenu(false);

        this.openMenu(
          menu,
          trigger
        );
      }

      openMenu(menu, trigger) {
        this.activeMenu = menu;
        this.activeTrigger = trigger;

        const views =
          menu.querySelector(
            '[data-menu-views]'
          );

        const mainView =
          menu.querySelector(
            '[data-main-view]'
          );

        if (views) {
          views.classList.remove('is-sub');
        }

        menu
          .querySelectorAll('[data-submenu]')
          .forEach((list) => {
            list.hidden = true;
          });

        menu.classList.add('is-open');

        menu.setAttribute(
          'aria-hidden',
          'false'
        );

        trigger.setAttribute(
          'aria-expanded',
          'true'
        );

        if (this.backdrop) {
          this.backdrop.hidden = false;
        }

        requestAnimationFrame(() => {
          if (mainView) {
            this.applyPanelHeightFor(
              mainView
            );
          }
        });
      }

      closeMenu(returnFocus = true) {
        if (!this.activeMenu) return;

        const menu = this.activeMenu;
        const trigger = this.activeTrigger;

        menu.classList.remove('is-open');

        menu.setAttribute(
          'aria-hidden',
          'true'
        );

        if (trigger) {
          trigger.setAttribute(
            'aria-expanded',
            'false'
          );
        }

        if (this.backdrop) {
          this.backdrop.hidden = true;
        }

        const views =
          menu.querySelector(
            '[data-menu-views]'
          );

        window.setTimeout(() => {
          if (views) {
            views.classList.remove(
              'is-sub'
            );
          }

          menu
            .querySelectorAll(
              '[data-submenu]'
            )
            .forEach((list) => {
              list.hidden = true;
            });
        }, 250);

        this.activeMenu = null;
        this.activeView = null;
        this.activeTrigger = null;

        if (
          returnFocus &&
          trigger
        ) {
          trigger.focus();
        }
      }

      openSubmenu(trigger) {
        if (!this.activeMenu) return;

        const submenuId =
          trigger.dataset.submenuTrigger;

        const title =
          trigger.dataset.submenuTitle || '';

        const url =
          trigger.dataset.submenuUrl || '#';

        const views =
          this.activeMenu.querySelector(
            '[data-menu-views]'
          );

        const subView =
          this.activeMenu.querySelector(
            '[data-sub-view]'
          );

        const shopLabel =
          this.activeMenu.querySelector(
            '[data-submenu-shop-label]'
          );

        const shopLink =
          this.activeMenu.querySelector(
            '[data-submenu-shop-link]'
          );

        const lists =
          this.activeMenu.querySelectorAll(
            '[data-submenu]'
          );

        const targetList =
          this.activeMenu.querySelector(
            `[data-submenu="${CSS.escape(submenuId)}"]`
          );

        if (!targetList) {
          window.location.href = url;
          return;
        }

        lists.forEach((list) => {
          list.hidden = true;
        });

        targetList.hidden = false;

        if (shopLabel) {
          shopLabel.textContent =
            `SHOP ${title}`;
        }

        if (shopLink) {
          shopLink.href = url;
        }

        if (views) {
          views.classList.add('is-sub');
        }

        const listContainer =
          targetList.closest(
            '.uhs-side-menu__list'
          );

        if (listContainer) {
          listContainer.scrollTop = 0;
        }

        requestAnimationFrame(() => {
          if (subView) {
            this.applyPanelHeightFor(
              subView
            );
          }
        });
      }

      backToMain() {
        if (!this.activeMenu) return;

        const views =
          this.activeMenu.querySelector(
            '[data-menu-views]'
          );

        const mainView =
          this.activeMenu.querySelector(
            '[data-main-view]'
          );

        if (views) {
          views.classList.remove('is-sub');
        }

        requestAnimationFrame(() => {
          if (mainView) {
            this.applyPanelHeightFor(
              mainView
            );
          }
        });
      }

      maxPanelHeight(menu) {
        const styles =
          window.getComputedStyle(menu);

        const top =
          parseFloat(styles.top) || 0;

        const bottomGap = 24;

        // The panel also has a CSS max-height (calc(100dvh - 142px)) with overflow: hidden.
        // Sizing the view taller than that pushed the end of the list below the panel's
        // clipped edge on short windows, where it could not be scrolled into view.
        const panel = menu.querySelector('.uhs-side-menu__panel');
        const cssMax = panel ? parseFloat(window.getComputedStyle(panel).maxHeight) : NaN;
        const available = window.innerHeight - top - bottomGap;

        const height = Math.max(200, available);

        return Number.isFinite(cssMax) ? Math.min(height, cssMax) : height;
      }

      applyPanelHeightFor(view) {
        if (
          !this.activeMenu ||
          !view
        ) {
          return;
        }

        const panel =
          this.activeMenu.querySelector(
            '.uhs-side-menu__panel'
          );

        if (!panel) return;

        this.activeView = view;

        const allViews =
          this.activeMenu.querySelectorAll(
            '.uhs-side-menu__view'
          );

        allViews.forEach((item) => {
          item.style.height = 'auto';
        });

        panel.style.height = 'auto';

        const naturalHeight =
          view.scrollHeight;

        const maxHeight =
          this.maxPanelHeight(
            this.activeMenu
          );

        const targetHeight =
          Math.min(
            naturalHeight,
            maxHeight
          );

        view.style.height =
          `${targetHeight}px`;

        panel.style.height =
          `${targetHeight}px`;
      }
    }
  );
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uhs-mobile-bottom-bar"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uhs-mobile-bottom-bar')) {
  customElements.define(
    'uhs-mobile-bottom-bar',
    class extends HTMLElement {
      connectedCallback() {
        this.backBtn = this.querySelector('[data-mbb-back]');
        this.keySearchBtn = this.querySelector('[data-mbb-key-search]');

        // Nothing to go back to on a fresh landing or a new tab, so don't offer it.
        if (this.backBtn) {
          if (window.history.length <= 1) {
            this.backBtn.hidden = true;
          } else {
            this.backBtn.addEventListener('click', () => window.history.back());
          }
        }

        if (this.keySearchBtn) {
          // The finder lives in the header group (sections/uhs-ymm-finder.liquid). If a
          // merchant has removed that section there is nothing to open, so hide the
          // button rather than ship a control that silently does nothing.
          if (!document.querySelector('uhs-ymm-finder')) {
            this.keySearchBtn.hidden = true;
          } else {
            this.keySearchBtn.addEventListener('click', () => {
              document.dispatchEvent(
                new CustomEvent('uhs:ymm:open', { detail: { opener: this.keySearchBtn } })
              );
            });
          }
        }

        this.initHeightVar();
      }

      disconnectedCallback() {
        if (this._resizeObserver) this._resizeObserver.disconnect();
        if (this._onResize) window.removeEventListener('resize', this._onResize);
        document.documentElement.style.removeProperty('--uhs-bottom-bar-h');
      }

      // assets/section-footer.css reads this to reserve clearance under the footer so a
      // fixed bar never covers the copyright. Same approach as the header's
      // --uhs-header-h (sections/uhs-header.liquid), rather than a magic number.
      initHeightVar() {
        const setVar = () => {
          document.documentElement.style.setProperty('--uhs-bottom-bar-h', `${this.offsetHeight}px`);
        };
        setVar();
        // border-box, not the default content-box: on iOS Safari the bottom padding follows
        // env(safe-area-inset-bottom), which changes as the toolbar collapses on scroll. A
        // padding-only change leaves the content box alone, so a content-box observer never
        // fired and the PDP purchase bar (bottom: var(--uhs-bottom-bar-h)) slid under this bar.
        // The resize listener backs it up, since iOS fires resize when the toolbar changes.
        if (window.ResizeObserver) {
          this._resizeObserver = new ResizeObserver(setVar);
          this._resizeObserver.observe(this, { box: 'border-box' });
        }
        this._onResize = setVar;
        window.addEventListener('resize', this._onResize);
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["uhs-ymm-finder"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('uhs-ymm-finder')) {
  customElements.define(
    'uhs-ymm-finder',
    class extends HTMLElement {
      connectedCallback() {
        this.bar = this.querySelector('.uhs-ymm__bar');
        this.closeBtn = this.querySelector('[data-ymm-close]');
        this.mobile = window.matchMedia('(max-width: 989px)');
        this.opener = null;

        this._onKeyup = (event) => {
          if (event.key === 'Escape') this.closeModal();
        };
        this._onOpenRequest = (event) => {
          // The requester passes itself so focus can be returned on close.
          this.openModal(event.detail && event.detail.opener);
        };
        this._onBreakpointChange = () => this.syncDialogRole();

        // sections/uhs-mobile-bottom-bar.liquid ("Key Search") is in the footer group
        // and cannot reference this element in Liquid, so it asks via the document.
        document.addEventListener('uhs:ymm:open', this._onOpenRequest);
        if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.closeModal());
        // Backdrop tap. The card is a child, so only a hit on the root itself counts.
        this.addEventListener('click', (event) => {
          if (event.target === this) this.closeModal();
        });
        this.mobile.addEventListener('change', this._onBreakpointChange);
        this.syncDialogRole();

        if (this.classList.contains('uhs-ymm--sticky')) {
          this._onScroll = () => {
            this.classList.toggle('uhs-ymm--scrolled', window.scrollY > 4);
          };
          this._onScroll();
          window.addEventListener('scroll', this._onScroll, { passive: true });

          // Publish this bar's height so anything stacking below it in the sticky
          // column can offset by a real measurement rather than a magic number —
          // same approach as --uhs-header-h (sections/uhs-header.liquid) and
          // --uhs-bottom-bar-h (sections/uhs-mobile-bottom-bar.liquid).
          // Inside this branch, so a non-sticky bar contributes no offset.
          this._publishHeight = () => {
            document.documentElement.style.setProperty('--uhs-ymm-h', `${this.offsetHeight}px`);
          };
          this._publishHeight();
          // Guarded the same way uhs-header.liquid guards its own observer.
          if (window.ResizeObserver) {
            this._heightObserver = new ResizeObserver(this._publishHeight);
            this._heightObserver.observe(this);
          } else {
            window.addEventListener('resize', this._publishHeight);
          }
        }
      }

      disconnectedCallback() {
        // Only the instance that published the variable clears it.
        if (this._publishHeight) {
          if (this._heightObserver) {
            this._heightObserver.disconnect();
            this._heightObserver = null;
          } else {
            window.removeEventListener('resize', this._publishHeight);
          }
          document.documentElement.style.removeProperty('--uhs-ymm-h');
        }
        if (this._onScroll) window.removeEventListener('scroll', this._onScroll);
        document.removeEventListener('uhs:ymm:open', this._onOpenRequest);
        document.removeEventListener('keyup', this._onKeyup);
        this.mobile.removeEventListener('change', this._onBreakpointChange);
      }

      // Only a dialog while it is acting as one. Above 990px this is a static bar in
      // the header group, so advertising role="dialog" there would be wrong - and any
      // open state has to be torn down when the viewport crosses the breakpoint.
      syncDialogRole() {
        if (this.mobile.matches) {
          this.setAttribute('role', 'dialog');
          this.setAttribute('aria-modal', 'true');
          this.setAttribute('aria-labelledby', `uhs-ymm-title-${this.dataset.section}`);
        } else {
          if (this.classList.contains('is-open')) this.closeModal();
          this.removeAttribute('role');
          this.removeAttribute('aria-modal');
          this.removeAttribute('aria-labelledby');
        }
      }

      openModal(opener) {
        if (!this.mobile.matches || this.classList.contains('is-open')) return;
        this.opener = opener || null;
        this.classList.add('is-open');
        if (this.opener && this.opener.setAttribute) this.opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('overflow-hidden-mobile');
        document.addEventListener('keyup', this._onKeyup);
        if (typeof trapFocus === 'function') trapFocus(this.bar, this.closeBtn);
      }

      closeModal() {
        if (!this.classList.contains('is-open')) return;
        this.classList.remove('is-open');
        document.body.classList.remove('overflow-hidden-mobile');
        document.removeEventListener('keyup', this._onKeyup);
        if (typeof removeTrapFocus === 'function') removeTrapFocus(this.opener);
        if (this.opener && this.opener.setAttribute) this.opener.setAttribute('aria-expanded', 'false');
        this.opener = null;
      }
    }
  );
}

  } catch(e) { console.error(e); }
})();
})();
